export const visit = (vm, at) => {
vm(require("timezone-utils/lang/he-il.lyaml"));
vm(require("ui-addon-i18n/lang/he-il.lyaml"));
vm(require("UIComponents/lang/he-il.lyaml"));
vm(require("MeetingsLib/lang/he-il.lyaml"));
vm(require("sanitize-text/lang/he-il.lyaml"));
vm(require("I18n/lang/he-il.lyaml"));
at({ "he-il": { "placeholderString": "\u05E4\u05D2\u05D9\u05E9\u05D5\u05EA" } });
};